export const restrictedSymbolsRegexps = {
    //firstName: /[^A-Za-zа-яА-ЯёЁ\- .`]/g,
    //familyName: /[^A-Za-zа-яА-ЯёЁ\- .`]/g,
    //patronymic: /[^A-Za-zа-яА-ЯёЁ\- .`]/g,
    //position: /[^а-яА-ЯёЁ]/g,
    login: /[^a-zA-Z0-9\-_.@]/g,
};
const allowedSymbolsRegexps = {
    //firstName: /[A-Za-zа-яА-ЯёЁ\- .`]/g,
    //familyName: /[A-Za-zа-яА-ЯёЁ\- .`]/g,
    //patronymic: /[A-Za-zа-яА-ЯёЁ\- .`]/g,
    //position: /[а-яА-ЯёЁ]/g,
    login: /[a-zA-Z0-9\-_.@]/g,
};
const finalRegexps = {
    email: /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
};

export const validationRules = {
    familyName: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length < 1, error: () => 'Фамилия не может быть пустой' },
            { on: v => v.length > 100, error: () => 'Фамилия не может быть длиннее 100 символов' },
            //{ on: v => restrictedSymbolsRegexps.familyName.test(v), error: v => `Имя не может содержать символы ${ v.replace(allowedSymbolsRegexps.familyName, '').replace(' ', '[пробел]') }` },
        ]
    },
    firstName: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length < 1, error: () => 'Имя не может быть пустым' },
            { on: v => v.length > 100, error: () => 'Имя не может быть длиннее 100 символов' },
            //{ on: v => restrictedSymbolsRegexps.firstName.test(v), error: v => `Фамилия не может содержать символы ${ v.replace(allowedSymbolsRegexps.firstName, '').replace(' ', '[пробел]') }` },
        ]
    },
    patronymic: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length > 100, error: () => 'Отчество не может быть длиннее 100 символов' },
            //{ on: v => restrictedSymbolsRegexps.patronymic.test(v), error: v => `Отчество не может содержать символы ${ v.replace(allowedSymbolsRegexps.patronymic, '').replace(' ', '[пробел]') }` },
        ]
    },
    position: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length > 255, error: () => 'Должность не может быть длиннее 255 символов' },
            //{ on: v => restrictedSymbolsRegexps.position.test(v), error: v => `Должность не может содержать символы ${ v.replace(allowedSymbolsRegexps.position, '').replace(' ', '[пробел]') }` },
        ]
    },
    login: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length < 1, error: () => 'Логин не может быть пустым' },
            { on: v => v.length > 100, error: () => 'Логин не может быть длиннее 100 символов' },
            { on: v => !/^[A-Za-z]/.test(v), error: () => 'Логин должен начинаться с буквы' },
            { on: v => /\.$/.test(v), error: () => 'Логин не может заканчиваться точкой' },
            { on: v => restrictedSymbolsRegexps.login.test(v), error: v => `Логин не может содержать символы ${ v.replace(allowedSymbolsRegexps.login, '').replace(' ', '[пробел]') }` },
        ]
    },
    email: {
        prepare: v => (v ?? '').trim().replace(/\s{2,}/g, ' '),
        validate: [
            { on: v => v.length < 1, error: () => 'Email не может быть пустым' },
            { on: v => !finalRegexps.email.test(v), error: () => `Email имеет неверный формат` },
        ]
    },
}

export function validateUserForm(formValues, keyNames, setError) {
    for (const [key, validation] of Object.entries(validationRules)) {
        const value = validation.prepare(formValues[key]);
        for (const rule of validation.validate) {
            if (rule.on(value)) {
                setError(rule.error(value));
                return false;
            }
        }
    }
    if(formValues.expiredKey && keyNames.length === 0) {
        setError('Не добавлены ключи для уведомления');
        return false;
    }
    setError('');
    return true;
}